export default __webpack_public_path__ + "static/media/real-estate.9960ebaa.png";